"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ShipmentCardGroupStyles = require("../../styles/ShipmentCardGroupStyles");

var _ShipmentCardStyles = require("../../styles/ShipmentCardStyles");

var _ShipmentCard = _interopRequireDefault(require("./ShipmentCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ShipmentCardGroup = function ShipmentCardGroup(_ref) {
  var id = _ref.id,
      className = _ref.className,
      shipment = _ref.shipment,
      tickets = _ref.tickets,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_ShipmentCardGroupStyles.Wrapper, {
    id: id,
    className: className,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentCardGroupStyles.WrapperTitle, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.IconShipment, {
    onClick: onSelect
  }, selected && /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.IconSmallShipment, null)), /*#__PURE__*/_react["default"].createElement(_ShipmentCardGroupStyles.Title, null, "Viaje: ", shipment)), tickets.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_ShipmentCard["default"], {
      id: item.id,
      key: item.id,
      group: true,
      ticket: item
    });
  }));
};

var _default = ShipmentCardGroup;
exports["default"] = _default;